import { render, staticRenderFns } from "./WeatherIcon.vue?vue&type=template&id=2b1d0c06&scoped=true"
import script from "./WeatherIcon.vue?vue&type=script&lang=ts"
export * from "./WeatherIcon.vue?vue&type=script&lang=ts"
import style0 from "./WeatherIcon.vue?vue&type=style&index=0&id=2b1d0c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d0c06",
  null
  
)

export default component.exports